import AuthStorage from "../utils/AuthStorage";
import { fetchApi } from "../utils/fetch-api";

export class GoogleApi {
  static async verifyCaptcha(payload) {
    let headers = {};
    try {
      const data = fetchApi({
        url: "/api/v1/captcha/google",
        options: {
          method: "POST",
          headers,
        },
        payload,
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async validateOauth() {
    let headers = {};
    try {
      const data = fetchApi(
        {
          url: "/api/v1/oauth/google/validate",
          options: {
            method: "POST",
            headers,
          },
        },
        (err, response) => {
          localStorage.removeItem("temp_txn_data");
          localStorage.removeItem("latest_explorer_check");
          if (err) return;
          if (response.status !== true && response.status !== "pending") return;
          if (response.two_factor) {
            const {
              token: two_f_token,
              two_factor,
              two_factor_type,
            } = response;
            AuthStorage.value = {
              two_factor,
              two_f_token,
              two_factor_type,
            };
          } else if (response?.data) {
            const [addr1, addr2, addr3] =
              response?.data?.wallets?.pulsar_data?._addresses?.reverse();
            const balance = response?.data?.wallets?.pulsar_data?.balance;
            AuthStorage.value = {
              token: response?.data?.token,
              user: response?.data?.user,
              wallets: {
                pulsar_data: { _addresses: [addr3, addr2, addr1], balance },
              }, // address order is important
            };
          } else if (response?.token) {
            AuthStorage.value = {
              token: response?.token,
            };
          }
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async googleTwoFactor() {
    let headers = {};
    try {
      const data = fetchApi({
        url: "/api/v1/two-factor/google/setup-2fa",
        options: {
          method: "GET",
          headers,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async googleConfirmTwoFactor(otp) {
    const headers = {};
    if (AuthStorage.value.two_f_token) {
      headers.authorization = `Bearer ${AuthStorage.value.two_f_token}`;
    }
    try {
      const data = fetchApi(
        {
          url: `/api/v1/two-factor/google/confirm-2fa?otp=${otp}`,
          options: {
            method: "GET",
            headers,
          },
        },
        (err, response) => {
          if (err) return;
          localStorage.removeItem("temp_txn_data");
          localStorage.removeItem("latest_explorer_check");
          if (response.status !== true) return;
          if (response?.data) {
            const [addr1, addr2, addr3] =
              response?.data?.wallets?.pulsar_data?._addresses?.reverse();
            const balance = response?.data?.wallets?.pulsar_data?.balance;
            AuthStorage.value = {
              token: response?.data?.token,
              user: response?.data?.user,
              wallets: {
                pulsar_data: { _addresses: [addr3, addr2, addr1], balance },
              }, // address order is important
            };
          }
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async disableGoogleTwoFactor(otp) {
    let headers = {};
    try {
      const data = fetchApi(
        {
          url: `/api/v1/two-factor/google/disable-2fa?otp=${otp}`,
          options: {
            method: "GET",
            headers,
          },
        },
        (err, response) => {
          if (err) return;
          if (response.status !== true) return;
          if (response?.data) {
            const [addr1, addr2, addr3] =
              response?.data?.wallets?.pulsar_data?._addresses?.reverse();
            const balance = response?.data?.wallets?.pulsar_data?.balance;
            AuthStorage.value = {
              token: response?.data?.token,
              user: response?.data?.user,
              wallets: {
                pulsar_data: { _addresses: [addr3, addr2, addr1], balance },
              }, // address order is important
            };
          }
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
}
